import {
  DateFormats,
} from "@/scripts/Common/DateFormats";

import moment from "moment";

export class HelperFunctions {

  private static deciamlCountRegEx = /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/

  public static GetDecimalsCount(value: string) {
    const match = value.match(this.deciamlCountRegEx);
    if (!match) {
      return 0;
    }
    return Math.max(
      0,
      (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0)
    );
  }

  public static IsEndDateAfterStartDate(startDate: string, endDate: string) {
    return new Date(endDate).getTime() > new Date(startDate).getTime()
  }

  public static IsEndDateAfterOrEqualToStartDate(startDate: string, endDate: string) {
    return new Date(endDate).getTime() >= new Date(startDate).getTime()
  }

  public static IsEmailValid(email: string) {
    const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return emailPattern.test(email);
  }

  public static CopyText(text: string) {
    navigator.clipboard.writeText(text).catch((_) => {
    });
  }

  public static isEmpty(str: string | undefined) {
    return (!str || str.length === 0);
  }

  // Laden des letzten Tages des Monats über angabe der 0 wird dieser automatisch geholt.
  public static getLastDayOfMonth(year: number, month: number): number {
    return new Date(year, month, 0).getDate()
  }
}

const copyObject = (value: any) => {
  try {
    return JSON.parse(JSON.stringify(value));
  } catch (_) {
    return undefined;
  }
}

const debounce = (fn: Function, ms = 500) => {
  let timeoutId: ReturnType<typeof setTimeout>;
  return function (this: any, ...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};

const getMinDateRestriction = moment().add(1, 'days').format(DateFormats.ISO8601_LONG);

const isEmpty = (value: string | undefined | null) => (!value || value.length === 0);

function isAbortError(error: any): boolean {
  return error instanceof DOMException && error.name === 'AbortError';
}

interface PlainObject {
  hasOwnProperty<K extends string>(key: K): this is Record<K, unknown>

  // Object.hasOwn() is intended as a replacement for Object.hasOwnProperty(). See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/hasOwn
  hasOwn<K extends string>(key: K): this is Record<K, unknown>
}

function isPlainObject(value: unknown): value is PlainObject {
  return !!value && typeof value === 'object' && !Array.isArray(value) && !(value instanceof Date)
}

const delayFunctionCall = async (fn: Function, ms: number) => {
  await new Promise(resolve => {
    setTimeout(resolve, ms);
  });

  fn.apply(null);
}

/**
 * Converts an object into a URL-encoded query string.
 *
 * This function takes an object with key-value pairs and converts it into a URL-encoded query string.
 *
 * @param {Object} obj - The object to be converted into a URL-encoded query string. Keys and values should be strings or numbers.
 * @param {string} [prefix=''] - A prefix to be added to the keys in the query string. Used for nested objects.
 * @returns {string} The URL-encoded query string.
 */
function buildQueryString(obj: Object, prefix: string = '') : string {
  let stringArr: string[] = [];

  for (const [key, value] of Object.entries(obj)) {
    const encodedKey = prefix ? `${prefix}[${encodeURIComponent(key)}]` : encodeURIComponent(key);

    if (value === undefined || value === null) {
      continue;
    } else if (Array.isArray(value)) {
      value.forEach(item => {
        stringArr.push(`${encodedKey}=${encodeURIComponent(item)}`);
      });
    } else if (value instanceof Date) {
      stringArr.push(`${encodedKey}=${encodeURIComponent(value.toISOString())}`);
    } else if (typeof value === 'boolean') {
      stringArr.push(`${encodedKey}=${value}`);
    } else if (typeof value === 'object') {
      stringArr.push(buildQueryString(value, encodedKey));
    } else {
      stringArr.push(`${encodedKey}=${encodeURIComponent(value)}`);
    }
  }

  return stringArr.join("&");
}


export {
  copyObject,
  isEmpty,
  debounce,
  getMinDateRestriction,
  isPlainObject,
  isAbortError,
  delayFunctionCall,
  buildQueryString
}
